import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PortalLayout from "../../admin-shared/PortalLayout";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import StoreLocationCaptureModal from "../components/StoreLocationCaptureModal";
import useTrialExp from "../components/useTrialExp";
import { permissionService } from "../services/permissionService";

const Layout = (props) => {
  const { Popup } = useTrialExp();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!permissionService.canAccessPartnerPath(location.pathname)) {
      navigate("/naturals/partner/overview", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <PortalLayout
      {...props}
      portalId="partner"
      Sidebar={Sidebar}
      Header={Header}
      Breadcrumb={Breadcrumb}
      TrialPopup={Popup}
      StoreLocationCaptureModal={StoreLocationCaptureModal}
    />
  );
};

export default Layout;
